import useSWR from 'swr'
import { twMerge } from 'tailwind-merge'
import { Loader } from 'shared/components/loader'
import { getPageCommentsKey } from 'modules/comments/api/get-page-comments'
import { useCommentsContext } from 'modules/comments/components/comments-list'
import { isCommunityExtra } from 'modules/comments/utils/is-community-extra'

interface LoadMoreButtonProps extends Omit<React.ComponentProps<'button'>, 'onClick'> {
  onClick: ({ lastCommentId, parentId }: { lastCommentId: number; parentId: number | null }) => void
  lastCommentId: number
  parentId: number | null
}

export const LoadMoreButton = ({
  children,
  className,
  lastCommentId,
  parentId,
  onClick,
  ...rest
}: LoadMoreButtonProps) => {
  const { commentsType, extra, currentSortOption } = useCommentsContext()

  const isCommunityComments = isCommunityExtra(extra)
  const resourceId = isCommunityComments ? extra.community.postId : extra.course.pageId
  const getPageCommentsQuery = useSWR(
    getPageCommentsKey({
      commentsType,
      lastCommentId,
      pageId: resourceId,
      parentId,
      sortOption: currentSortOption,
    }),
  )

  return (
    <button
      className={twMerge(
        'mx-auto my-2 block cursor-pointer p-1.5 text-center text-base font-medium transition-colors hover:text-brand-primary',
        className,
      )}
      disabled={getPageCommentsQuery.isLoading}
      onClick={() => onClick({ lastCommentId, parentId })}
      {...rest}
    >
      {getPageCommentsQuery.isLoading ? <Loader /> : children}
    </button>
  )
}
